import script from "./SearchPageMobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageMobileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageMobileMenu.vue?vue&type=style&index=0&id=1c2dcc89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2dcc89"]])

export default __exports__